import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useLocation, useRouteMatch } from "react-router-dom";
import Food from "./Food/Food";
import Drink from "./Drink/Drink";
import Team from "./Team/Team";
import { Route, Switch, NavLink } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import theBG1 from "../../../assets/images/food2.png";
import theBG2 from "../../../assets/images/drink3.png";
import theBG3 from "../../../assets/images/space3.png";
const useStyles = makeStyles((theme) => ({
  root: {
    WebkitAnimation: "breath 3s ease infinite",
    MozAnimation: "breath 3s ease infinite",
    animation: "breath 3s ease infinite",
    marginTop: "5rem",
    display: "flex",
    backgroundRepeat: "no-repeat",
    boxSizing: "border-box",
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
    textAlign: "center",
    borderColor: "#996f32",
    borderStyle: "solid",
    padding: "1rem",
    margin: "5rem",
    borderWidth: "5px",
    textTransform: "uppercase",
    fontWeight: "bold",
    backgroundOrigin: "padding-box, border-box",
  },
  strikeThrough: {
    textDecoration: "line-through",
  },
}));
const routes = [
  {
    path: "food",
    child: <Food />,
  },
  {
    path: "drink",
    child: <Drink />,
  },
  {
    path: "team",
    child: <Team />,
  },
];
export default function AboutNav({ imageChange, colorChange, transChange }) {
  const classes = useStyles();
  const { path } = useRouteMatch();
  let { location } = useLocation();

  return (
    <div>
      <CSSTransition timeout={300} classNames="list-transition" appear>
        <div className={classes.root} data-aos="zoom-in" data-aos-duration="1000">
          <NavLink
            activeClassName={classes.strikeThrough}
            style={{ color: "#996f32" }}
            to={`${path}/food`}
            onClick={() => {
              transChange.handleTrans();
              imageChange.changeImage(theBG1);
              colorChange.changeColor(
                "linear-gradient(270deg, #E7A977, #EBBE9B)"
              );
            }}
          >
            <div className="strike">Thức ăn</div>
          </NavLink>
          <NavLink
            activeClassName={classes.strikeThrough}
            style={{ color: "#996f32" }}
            to={`${path}/drink`}
            onClick={() => {
              transChange.handleTrans();
              imageChange.changeImage(theBG2);
              colorChange.changeColor(
                "linear-gradient(270deg, #2a4343, #4b7474)"
              );
            }}
          >
            <div className="strike">Đồ uống</div>
          </NavLink>
          <NavLink
            activeClassName={classes.strikeThrough}
            style={{ color: "#996f32" }}
            to={`${path}/team`}
            onClick={() => {
              transChange.handleTrans();
              imageChange.changeImage(theBG3);
              colorChange.changeColor(
                "linear-gradient(270deg, #a59890, #cac2bd)"
              );
            }}
          >
            <div className="strike">
              <div className="strike-active">Đội ngũ</div>
            </div>
          </NavLink>
        </div>
      </CSSTransition>
      <TransitionGroup>
        {routes.map((text, id) => (
          <CSSTransition classNames="fade" timeout={500} key={id}>
            <Switch location={location}>
              <Route
                exact
                path={`${path}/${text.path}`}
                children={text.child}
              />
            </Switch>
          </CSSTransition>
        ))}
      </TransitionGroup>
    </div>
  );
}
